import { render, staticRenderFns } from "./TestimonialItem.vue?vue&type=template&id=590de481&scoped=true"
import script from "./TestimonialItem.vue?vue&type=script&lang=js"
export * from "./TestimonialItem.vue?vue&type=script&lang=js"
import style0 from "./TestimonialItem.vue?vue&type=style&index=0&id=590de481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590de481",
  null
  
)

export default component.exports